import { type ReactElement } from 'react';
import { Box, Divider, Text } from '@citibox-panel/ui';

// The screen's own words, set like the other operations surfaces' intros so the three title
// themselves identically.
//
// TODO: i18n — copy en ES hasta Fase 1.
export function PageIntro(): ReactElement {
  return (
    <Box sx={{ mb: 4 }}>
      <Text variant="overline" component="p" bold dense>
        SUPPLY · ETIQUETAS QR LOCK1
      </Text>
      <Divider sx={{ my: 2 }} />
      <Text variant="h5" component="h1" bold>
        Generador de QRs
      </Text>
      <Box sx={{ maxWidth: '62ch', mt: 1 }}>
        <Text variant="body1">
          Genera los lotes de etiquetas QR de las cerraduras LOCK1 que se envían a imprimir a
          Valver/Gureak. Cada lote se genera en segundo plano y se descarga como CSV cuando está listo.
        </Text>
      </Box>
    </Box>
  );
}
